import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectIsPublishPaymentStatusVisible, selectPaymentDataByType } from '../../selectors/paymentProcessing';
import { EPaymentType } from '../../types/reducers/paymentProcessing';
import { PublishPaymentStatus } from './PublishPaymentStatus';

export const PublishPaymentStatusContainer = () => {
  const isVisible = useSelector(selectIsPublishPaymentStatusVisible);
  const payment = useSelector(selectPaymentDataByType(EPaymentType.Publish));

  if (!isVisible) {
    return null;
  }

  return <PublishPaymentStatus status={payment!.status!} />;
};
